<template>
  <div class="document-field">
    <template v-if="!viewMode && !disabled">
      <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
      <vs-upload :disabled="disabled" text="Enviar Arquivo" :fileName="'file'" :multiple="multiple" automatic :action="$store.state.auth.api_url + '/save-image'"
        :accept="accept"
        :data="{ application_token: $store.state.auth.app_token, session_token: $store.state.auth.token }" limit="1"
        @change="onUploadChange"
        @on-success="onSuccess($event, field.hash)"
        @on-error="onUploadError"
        @on-delete="deleteDocument($event, field.hash)" />
    </template>
    <!-- single-upload  -->
    <template v-else-if="viewMode && field.payload !== null">
      <div @click.stop="onOpenDocument($event)">
        <label class="vs-input--label"> {{ $displayLabel(field, 'title') }} <span v-if="field.mandatory" style="color: red;"> *</span> </label>
        <div class="con-upload">
          <div class="con-img-upload">
            <div class="img-upload">
              <button type="button" class="btn-x-file" @click="onClickClose"><i translate="translate"
                  class="material-icons notranslate">clear</i></button>
              <h4 class="text-archive"><i translate="translate" class="material-icons notranslate">
                  description
                </i><span>
                  Clique para visualizar o documento
                </span></h4>
            </div>
            <div class="con-input-upload disabled-upload upload-field-label">
              <input type="file" accept="all" disabled="disabled"><span class="text-input">Enviar
                Arquivo</span>
              <span class="input-progress" style="width: 0%;"></span>
              <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i
                  translate="translate" class="material-icons notranslate">cloud_upload</i></button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { props } from 'vue-prism-component';

export default {
  name: 'DocumentField',
  props: {
    field: {
      type: Object,
      required: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: 'all'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    };
  },
  methods: {
    deleteDocument(event, fieldHash) {
      this.$emit('uploadPending', false);
      this.$emit('onDelete', event, fieldHash);
    },
    onUploadChange() {
      this.$emit('uploadPending', true);
    },
    onUploadError() {
      this.$emit('uploadPending', false);
      this.$emit('onError');
    },
    onSuccess(event, fieldHash) {
      this.$emit('uploadPending', false);
      this.$emit('onSuccess', event, fieldHash);
    },
    onOpenDocument(event) {
      this.$emit('onOpenDocument', event);
    },
    onClickClose() {
      this.$emit('onClickClose');
    },
  },
  computed: {
    // Your computed properties go here
  },
  mounted() {
    // Code to run when the component is mounted
  }
};
</script>

<style scoped>
.document-field {
  /* Your component styles go here */
}
</style>
